
import { useState, useEffect } from "react";

import "./App.css";

function App() {
  const [tab, setTab] = useState("home");
const [menuOpen, setMenuOpen] = useState(false);

  const [showNavTitle, setShowNavTitle] = useState(false);
useEffect(() => {
  const handleScroll = () => {
    if (window.scrollY > 150) {
      setShowNavTitle(true);
    } else {
      setShowNavTitle(false);
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => window.removeEventListener("scroll", handleScroll);
}, []);



  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>

      {/* NAVBAR */}
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "1px 20px",
        backgroundColor: "#ffffff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        position: "sticky",
        top: 0
      }}>
        <div style={{ 
  display: "flex",
  alignItems: "center",
  gap: "10px",
  maxWidth: "70%",
  overflow: "hidden"
}}>

  <img
    src="/logo.png"
    alt="Logo"
    style={{
      height: "80px",
      background: "white",
      padding: "6px",
      borderRadius: "6px"
    }}
  />

  {showNavTitle && (
  <div
  style={{
    overflow: "hidden",
    maxHeight: showNavTitle ? "40px" : "0px",
    transition: "max-height 0.8s ease"
  }}
>
  {showNavTitle && (
  <h2 style={{
    margin: 0,
    color: "#6b4f2a",
whiteSpace: "nowrap",
textOverflow: "ellipsis",

    letterSpacing: "0.5px",
    lineHeight: "1.2"
  }} className="Title">
    Shri Ganesh Packaging Industries

  </h2>
)}

</div>



)}

</div>


        <div>

          <div style={{ position: "relative" }}>
{/* DESKTOP MENU */}
<div className="desktopMenu">
  <button onClick={() => setTab("home")} style={tabStyle(tab === "home")}>Home</button>
  <button onClick={() => setTab("about")} style={tabStyle(tab === "about")}>About</button>
  <button onClick={() => setTab("products")} style={tabStyle(tab === "products")}>Products</button>
  <button onClick={() => setTab("contact")} style={tabStyle(tab === "contact")}>Contact</button>
</div>

  <div
  className="hamburgerOnly"
  onClick={() => setMenuOpen(!menuOpen)}
  style={{
    fontSize: "28px",
    cursor: "pointer",
    userSelect: "none"
  }}
>

  
    ☰
  </div>

  {menuOpen && (
  <div style={{
    position: "fixed",
    top: 0,
    right: 0,
    width: "50vw",
    height: "100vh",
    background: "#ffffff",
    padding: "25px",
    boxShadow: "-4px 0 12px rgba(0,0,0,0.3)",
    display: "flex",
    flexDirection: "column",
    gap: "18px",
    zIndex: 9999,
    transition: "transform 0.6s ease",
    transform: menuOpen ? "translateX(0)" : "translateX(100%)",

  }}>
<div
  onClick={() => setMenuOpen(false)}
  style={{
    fontSize: "22px",
    cursor: "pointer",
    alignSelf: "flex-end"
  }}
>
  ✕
</div>


      <button onClick={() => {setTab("home"); setMenuOpen(false);}} style={tabStyle(tab === "home")}>Home</button>
      <button onClick={() => {setTab("about"); setMenuOpen(false);}} style={tabStyle(tab === "about")}>About</button>
      <button onClick={() => {setTab("products"); setMenuOpen(false);}} style={tabStyle(tab === "products")}>Products</button>
      <button onClick={() => {setTab("contact"); setMenuOpen(false);}} style={tabStyle(tab === "contact")}>Contact</button>
    </div>
  )}

</div>

        </div>
      </div>

      {/* HOME */}
      {tab === "home" && (
  <div>

    {/* HERO */}
    <div
      style={{
        backgroundImage:
          "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/bg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "white",
        textAlign: "center",
        padding: "140px 20px"
      }}
    >
      <h1 style={{ fontSize: "42px" }}>
        Shri Ganesh Packaging Industries
      </h1>
      <p style={{ maxWidth: "900px", margin: "20px auto", fontSize: "18px" }}>
        We are a trusted corrugated packaging manufacturer with two advanced manufacturing units in Kota and Hindaun City, backed by 25+ years of industry experience. Serving 600+ happy clients, equipped with 4-color offset printing and a combined annual production capacity of over 2000 tons, we provide reliable, innovative, and high-quality packaging solutions for medium-scale industries, startups, and export houses.

      </p>
    </div>
{/* STATS */}
<div style={{
  background: "#ffffff",
  padding: "60px 20px"
}}>
  <div style={{
    maxWidth: "1000px",
    margin: "auto",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "25px",
    textAlign: "center"
  }}>

    <div style={statCard}>
      <h2>10+</h2>
      <p>Years Experience</p>
    </div>

    <div style={statCard}>
      <h2>500+</h2>
      <p>Happy Clients</p>
    </div>

    <div style={statCard}>
      <h2>1000+</h2>
      <p>Orders Delivered</p>
    </div>

    <div style={statCard}>
      <h2>24x7</h2>
      <p>Support</p>
    </div>

  </div>
</div>

    {/* INTRO */}
    

    {/* WHY CHOOSE US */}
    <div style={{ background: "#f4f4f4", padding: "70px 20px" }}>
      <h2 style={{ textAlign: "center", color: "#6b4f2a" }}>
        Why Choose Us
      </h2>

      <ul style={{
        maxWidth: "800px",
        margin: "30px auto",
        lineHeight: "32px",
        fontSize: "16px"
      }}>
        <li>✔ High-quality kraft paper material</li>
        <li>✔ 3-Ply, 5-Ply and 7-Ply corrugated boxes</li>
        <li>✔ Custom sizes as per customer requirement</li>
        <li>✔ Strong, durable and safe packaging</li>
        <li>✔ Eco-friendly & recyclable materials</li>
        <li>✔ Competitive factory pricing</li>
      </ul>
    </div>

    {/* OUR JOURNEY */}
  
    {/* INDUSTRIES */}
{/* GALLERY */}
<div style={{ padding: "70px 20px", textAlign: "center" }}>

  <h2 style={{ color: "#6b4f2a" }}>Our Infrastructure</h2>

  <div style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "20px",
    maxWidth: "1100px",
    margin: "40px auto"
  }}>

    <img src="/gallery1.jpg" style={imgStyle} />
    <img src="/gallery2.jpg" style={imgStyle} />
    <img src="/gallery3.jpg" style={imgStyle} />
    <img src="/gallery4.jpg" style={imgStyle} />

  </div>

</div>

{/* CALL TO ACTION */}
<div style={{
  background: "#6b4f2a",
  color: "#ffffff",
  padding: "70px 20px",
  textAlign: "center"
}}>
  <h2>Looking for Reliable Packaging Partner?</h2>
  <p style={{ margin: "20px 0", fontSize: "18px" }}>
    Get best quality corrugated boxes at competitive factory prices.
  </p>

  <a
    href="https://wa.me/918005805401"
    target="_blank"
    style={{
      background: "#ffffff",
      color: "#6b4f2a",
      padding: "12px 28px",
      borderRadius: "30px",
      fontWeight: "bold",
      textDecoration: "none"
    }}
  >
    Get Quote on WhatsApp
  </a>
</div>

    <div style={{ background: "#f4f4f4", padding: "70px 20px" }}>
      <h2 style={{ textAlign: "center", color: "#6b4f2a" }}>
        Industries We Serve
      </h2>

      <p style={{ textAlign: "center", fontSize: "16px" }}>
        E-Commerce • FMCG • Electronics • Industrial Goods • Logistics • Retail
      </p>
    </div>

  </div>
)}


      {/* ABOUT */}
      {tab === "about" && (
  <div style={{ padding: "70px 20px", textAlign: "center" }}>

    <h2>About Shri Ganesh Packaging Industries</h2>

    <p style={{ maxWidth: "900px", margin: "20px auto", fontSize: "16px" }}>
      With two well-established manufacturing units located in Kota and Hindaun City, we bring more than 25 years of experience in the packaging industry. Our Hindaun City unit has been successfully serving customers for over 25 years, while our Kota facility has been delivering quality packaging solutions for more than 11 years. We proudly serve 600+ happy clients across multiple industries and are equipped with advanced 4-color offset printing machines to meet diverse branding and packaging requirements.

With a combined annual production capacity of over 2000 tons, our infrastructure is fully capable of catering to medium-scale industries, new businesses, startups, and export houses. We continuously work with our clients to develop innovative packaging solutions and are always open to implementing new ideas to improve performance, design, and cost efficiency. Many of our customers have been associated with us for more than a decade, which reflects our strong commitment to consistent quality, dependable service, and complete customer satisfaction.

    </p>

    <p style={{ maxWidth: "900px", margin: "20px auto", fontSize: "16px" }}>
      With years of experience and a skilled workforce, we focus on consistent
      quality, modern manufacturing practices and timely delivery. Our mission
      is to become a trusted long-term packaging partner for our customers.
    </p>

    <h3 style={{ marginTop: "40px" }}>Our Core Values</h3>

    <ul style={{
      maxWidth: "600px",
      margin: "20px auto",
      textAlign: "left",
      lineHeight: "30px"
    }}>
      <li>✔ Quality First Approach</li>
      <li>✔ Customer Satisfaction</li>
      <li>✔ Ethical Business Practices</li>
      <li>✔ Timely Delivery</li>
      <li>✔ Continuous Improvement</li>
    </ul>
<h3 style={{ marginTop: "40px", color: "#6b4f2a" }}>Who We Are</h3>

<p style={{ maxWidth: "900px", margin: "20px auto", fontSize: "16px" }}>
  Shri Ganesh Packaging Industries is a reliable corrugated box manufacturer
  based in Kota, Rajasthan. We specialize in manufacturing high-quality
  corrugated packaging boxes that provide excellent strength and protection
  for a wide range of products.
</p>

<h3 style={{ marginTop: "40px", color: "#6b4f2a" }}>Our Journey</h3>

<p style={{ maxWidth: "900px", margin: "20px auto", fontSize: "16px" }}>
  Our journey began with a simple goal — to provide reliable and strong
  packaging solutions to businesses. Over the years, we have grown with
  our customers by continuously improving quality, adopting better
  manufacturing practices and maintaining trust through timely delivery
  and consistent performance.
</p>

  </div>
)}

{/* PRODUCTS */}
{/* PRODUCTS */}
{tab === "products" && (
  <div style={{ padding: "60px 20px", textAlign: "center" }}>

    <h2>Our Products</h2>

    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "25px",
      maxWidth: "1100px",
      margin: "40px auto"
    }}>

      <div style={cardStyle}>
        <img src="/product1.jpg" style={imgStyle} />
        <h4>Corrugated Packaging Boxes</h4>
        <p>Strong boxes for shipping & storage.</p>
      </div>

      <div style={cardStyle}>
        <img src="/product2.jpg" style={imgStyle} />
        <h4>Printed Corrugated Boxes</h4>
        <p>Custom branding boxes.</p>
      </div>

      <div style={cardStyle}>
        <img src="/product3.jpg" style={imgStyle} />
        <h4>Die-Cut Boxes</h4>
        <p>Special shape boxes.</p>
      </div>

      <div style={cardStyle}>
        <img src="/product4.jpg" style={imgStyle} />
        <h4>Heavy Duty Boxes</h4>
        <p>High strength packaging.</p>
      </div>

      <div style={cardStyle}>
        <img src="/product5.jpg" style={imgStyle} />
        <h4>Mono Cartons</h4>
        <p>Retail packaging boxes.</p>
      </div>

      <div style={cardStyle}>
        <img src="/product6.jpg" style={imgStyle} />
        <h4>Custom Size Boxes</h4>
        <p>As per requirement.</p>
      </div>

    </div>
  </div>
)}


      {/* CONTACT */}
      {tab === "contact" && (
  <div style={{
    backgroundColor: "#f4f4f4",
    padding: "60px 20px"
  }}>

    <h2 style={{ textAlign: "center" }}>Contact Us</h2>

    <div style={{
      maxWidth: "1100px",
      margin: "40px auto",
      display: "flex",
      flexWrap: "wrap",
      gap: "30px"
    }}>

      {/* LEFT SIDE */}
      <div style={{ flex: "1", minWidth: "300px" }}>

        <h3>Shri Ganesh Packaging Industries</h3>

        <p>
          F-145, Road No. 5,<br />
          Indraprasth Industrial Area,<br />
          Kota, Rajasthan – 324007
        </p>

        <p><b>Phone / WhatsApp:</b> +91 80058 05401</p>
        <p><b>Email:</b> ganeshpackkota@gmail.com</p>

        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d451.5047374668991!2d75.8594535!3d25.1344095!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396f8598c5cfb593%3A0x317fce4c34ee6acb!2sShri%20Ganesh%20Packaging%20Industries!5e0!3m2!1sen!2sin!4v1769309775821!5m2!1sen!2sin"
          width="100%"
          height="280"
          style={{ border: 0, borderRadius: "10px", marginTop: "15px" }}
          loading="lazy"
        ></iframe>

      </div>

      {/* RIGHT SIDE */}
      <div style={{
        flex: "1",
        minWidth: "300px",
        background: "#fff",
        padding: "25px",
        borderRadius: "10px",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)"
      }}>

       <h3>Send Enquiry</h3>

<input
  type="text"
  id="name"
  placeholder="Your Name"
  style={inputStyle}
/>

<input
  type="tel"
  id="phone"
  placeholder="Phone Number"
  style={inputStyle}
/>

<textarea
  id="message"
  placeholder="Your Message"
  rows="4"
  style={inputStyle}
></textarea>

<button
  style={submitBtn}
  onClick={() => {
  const name = document.getElementById("name").value.trim();
  const phone = document.getElementById("phone").value.trim();
  const message = document.getElementById("message").value.trim();

  if (name === "" || phone === "") {
    alert("Please enter Name and Phone Number");
    return;
  }

  const text = `Name: ${name}%0APhone: ${phone}%0AMessage: ${message}`;
  window.open(
    `https://wa.me/918005805401?text=${text}`,
    "_blank"
  );

  alert("Thank you! We will contact you shortly.");

  document.getElementById("name").value = "";
  document.getElementById("phone").value = "";
  document.getElementById("message").value = "";
}}

>
  Send on WhatsApp
</button>


      </div>

    </div>

  </div>
)}



      {/* FOOTER */}
	{/* WHATSAPP FLOAT BUTTON */}
{/* WHATSAPP FLOATING BUTTON */}
<a
  href="https://wa.me/918005805401"
  target="_blank"
  style={{
    position: "fixed",
    bottom: "25px",
    right: "25px",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    zIndex: 9999,
    textDecoration: "none"
  }}
>
  <img
    src="/whatsapp-icon.png"
    alt="WhatsApp"
    style={{ width: "36px", height: "36px" }}
  />
</a>

      <div style={{
        backgroundColor: "#2b1c0f",
        color: "#fff",
        textAlign: "center",
        padding: "15px"
      }}>
        © 2026 Shri Ganesh Packaging Industries
      </div>

    </div>
  );
}

function tabStyle(active) {
  return {
    marginRight: "25px",
    padding: "10px 6px",
    fontWeight: "600",
    fontSize: "15px",
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    color: active ? "#6b4f2a" : "#222",
    borderBottom: active ? "3px solid #6b4f2a" : "3px solid transparent",
  };
}

const cardStyle = {
  background: "#ffffff",
  padding: "15px",
  borderRadius: "12px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  transition: "0.3s",
  cursor: "pointer"
};

const imgStyle = {
  width: "100%",
  height: "200px",
  objectFit: "cover",
  borderRadius: "8px",
  marginBottom: "10px"
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  margin: "10px 0",
  borderRadius: "5px",
  border: "1px solid #ccc",
  fontSize: "14px"
};

const submitBtn = {
  width: "100%",
  padding: "12px",
  backgroundColor: "#6b4f2a",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  fontSize: "16px",
  cursor: "pointer"
};

const statCard = {
  background: "#f4f4f4",
  padding: "25px",
  borderRadius: "12px",
  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
  fontWeight: "bold"
};

export default App;
